<script lang="ts">
  import CheckmarkImage from "../assets/icons/checkmark.svg";
  import CheckmarkSelectedImage from "../assets/icons/checkmark-selected.svg";

  import { t } from "../stores/translations";

  import Chip from "./shared/Chip.svelte";
  import { advice } from "../stores/advice";

  export let adviceType;
  export let mattress;
  export let mattressIndex;
  export let checkTwoPersonWithPartner;

  const reasons = setReasons();

  function setReasons(): { [mattress: string]: Array<string> } {
    return Object.entries($advice[adviceType]).reduce(
      (result, [mattress, answers]) => {
        Object.values(answers).forEach((answer) => {
          if (!result[mattress]) result[mattress] = [];

          result[mattress] = [...result[mattress], ...answer.reasons];
        });

        return result;
      },
      {}
    );
  }

  function getChipItems(mattress: string): Array<{
    questionSlug: string;
    answerSlug: string;
  }> {
    const chipItemSlugs = ["length-weight", "body-type"];

    return Object.entries($advice[adviceType][mattress]).reduce(
      (result, [questionSlug, answer]) => {
        if (!chipItemSlugs.includes(questionSlug)) return result;

        result.push({
          questionSlug,
          answerSlug: answer["value"],
        });

        return result;
      },
      []
    );
  }
</script>

{#if $advice && $advice["advice-partner"] && $advice["mattress-type"] === "two-person-mattress"}
  <p class="person-identifier">
    {$t(
      adviceType === "advice-primary"
        ? "advice.header.for-you"
        : "advice.header.for-your-partner"
    )}
  </p>
{/if}

<p
  class="chips-header"
  class:two-person-with-partner={checkTwoPersonWithPartner}
>
  {$t(
    $advice["advice-partner"]
      ? "advice.with-properties"
      : "advice.your-support-advice"
  )}
</p>

<div
  class="chips-container"
  class:two-person-with-partner={checkTwoPersonWithPartner}
>
  {#each getChipItems(mattress) as chipItem}
    <Chip
      questionSlug={chipItem.questionSlug}
      answerSlug={chipItem.answerSlug}
    />
  {/each}
</div>

<div class="reasons-container">
  <h2>{$t("advice.reasons.header")}</h2>

  <ul class="reasons-list">
    {#each reasons[mattress] as reason}
      <li>
        <img
          src={mattressIndex === 0 ? CheckmarkSelectedImage : CheckmarkImage}
          alt="Checkmark icon"
        />

        <p>{$t(`advice.reasons.${reason}`)}</p>
      </li>
    {/each}
  </ul>
</div>

<style lang="scss">
  @import "src/lib/styles/variables.scss";
  @import "src/lib/styles/mixins.scss";

  .person-identifier {
    font-family: "Roboto";
    font-weight: $font-weight-bold;
    font-size: $font-size-large;
    margin: 0.5rem auto auto;
    line-height: 1.25;
    display: flex;
    justify-content: center;
  }

  .chips-header {
    font-weight: $font-weight-bold;
    font-size: $font-size-medium;
    line-height: 1.5;
    margin: 0.5rem auto;
    display: flex;
    justify-content: center;
  }

  .chips-container {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    justify-content: center;
  }

  .reasons-container {
    h2 {
      margin-top: 1.5rem;
      font-weight: $font-weight-bold;
      font-size: $font-size-medium;
    }

    & > .reasons-list {
      list-style: none;
      padding: 0;

      & > li {
        display: flex;
        align-items: flex-start;

        & > p {
          line-height: 1.2;
          margin: 0.5rem 0;

          &:first-of-type {
            margin-top: 0;
          }
        }

        & > img {
          width: 24px;
          margin-right: 0.75rem;
        }
      }
    }
  }

  @include desktop {
    .reasons-container {
      & > .reasons-list {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;

        & > li {
          & > p {
            margin: 0;
          }
        }
      }
    }

    .chips-container {
      display: flex;
      flex-direction: row;
      gap: 0.5rem;
    }

    .person-identifier,
    .two-person-with-partner {
      justify-content: flex-start;
    }
  }
</style>
